var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":"","filterable":""},on:{"change":_vm.onChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.optionArr),function(option,i){return _c('el-option',{key:i,attrs:{"label":option[_vm.labelKey],"value":option[_vm.valueKey]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }